export default "__VITE_ASSET__DNb5r4t$__"